export class TipoEnvioModel {
  constructor({ id, nome, flagVisivelEnvioMaterial = false, flagVisivelRoteirizacao = false }) {
    this.id = id;
    this.nome = nome;
    this.flagVisivelEnvioMaterial = flagVisivelEnvioMaterial;
    this.flagVisivelRoteirizacao = flagVisivelRoteirizacao
  }
}
